import React from 'react';
import FeatureCards from "../../../components/FeatureCards/FeatureCards";
import CTA from "../../../components/Constant/cta/CTA";
import TimelineSection from "../../../components/TimelineSection/TimelineSection";
import WhySection from "../../../components/WhySection/WhySection";
import LocationTimeline from "../../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards ";

export default function FundsAssetManagementLicenseMalta() {

    return (
        <main className='main'>

            <IntroSection
                title="Funds & Asset Management License – Malta (MFSA)"
                subtitle="Manage Funds and Investments with EU Recognition"
                description="Malta is a leading jurisdiction for asset management companies and investment funds, offering a full range of AIFM, UCITS, and PIF structures under the supervision of the Malta Financial Services Authority (MFSA). With passporting rights across the European Economic Area (EEA) and a reputation as a flexible but credible EU fund hub, Malta is an attractive alternative to Luxembourg and Ireland."
                badges={[
                    "UCITS Funds",
                    "Alternative Investment Funds (AIF)",
                    "Professional Investor Funds (PIF)",
                    "Asset Management Firms"
                ]}
                buttonText="Request a Malta Funds Proposal →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/services/funds-asset-management-license-malta-hero.png")}
                imageAlt="Malta Funds & Asset Management"
            />

            <section className='section'>
                <div className="container">

                    <WhySection
                        title='Why Choose Malta for Asset Management?'
                        blocks={
                            [
                                {
                                    items:
                                        [
                                            {
                                                title: "EU & Global Recognition",
                                                text: "Trusted by investors and regulators worldwide."
                                            },
                                            {
                                                title: "MFSA Regulated",
                                                text: "Full compliance with EU AIFMD and UCITS directives."
                                            },
                                            {
                                                title: "Passporting Rights",
                                                text: "Market funds across the EEA."
                                            },
                                            {
                                                title: "Flexible Fund Options",
                                                text: "UCITS, AIFs, and PIFs for different investor profiles."
                                            },
                                            {
                                                title: "Investor Confidence",
                                                text: "Regulated status attracts institutional investors."
                                            },
                                            {
                                                title: "Banking & Custody Access",
                                                text: "Easier to secure custodians and administrators."
                                            }
                                        ]
                                }
                            ]
                        }
                    />

                    <InfoBlocks
                        title="Types of Fund & Asset Management Licenses"
                        blocks={[
                            {
                                title: "UCITS (Retail Funds)",
                                items: [
                                    { text: "EU-harmonized retail investment funds." },
                                    { text: "Eligible for marketing across all EEA countries." },
                                    { text: "Strict diversification and risk rules." },
                                    { text: "Capital Requirement: €125,000–€300,000." }
                                ]
                            },
                            {
                                title: "AIF (Alternative Investment Fund)",
                                items: [
                                    { text: "Designed for professional investors." },
                                    { text: "Covers hedge funds, private equity, venture capital, real estate funds." },
                                    { text: "Licensed under AIFMD, full EU recognition." },
                                    { text: "Capital Requirement: €125,000–€300,000." }
                                ]
                            },
                            {
                                title: "PIF (Professional Investor Fund)",
                                items: [
                                    { text: "Malta-specific structure." },
                                    { text: "Flexible regime for HNWIs and institutional investors." },
                                    { text: "Lower regulatory burden compared to UCITS/AIF." },
                                    { text: "Minimum investment per investor: €100,000." },
                                    { text: "Can be set up as umbrella funds with multiple sub-funds." }
                                ]
                            },
                            {
                                title: "Asset Management Firm License",
                                items: [
                                    { text: "Investment management services under MiFID II." },
                                    { text: "Portfolio management, discretionary & advisory mandates." },
                                    { text: "Can manage UCITS, AIFs, or PIFs." },
                                    { text: "Capital Requirement: €125,000 (management company)." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Benefits of a Malta Fund License"
                        subtitle=''
                        item={
                            [
                                {
                                    title: "EU Passporting Rights",
                                    text: "Fund marketing across the EU."
                                },
                                {
                                    title: "Strong Legal Framework",
                                    text: "Aligned with Solvency II, AIFMD, and UCITS rules."
                                },
                                {
                                    title: "Investor Attraction",
                                    text: "Easier to raise capital from institutional and retail investors."
                                },
                                {
                                    title: "Flexible Structures",
                                    text: "PIFs for HNWIs, UCITS for retail, AIFs for professional investors."
                                },
                                {
                                    title: "Cost-Effective",
                                    text: "Lower costs compared to Luxembourg or Ireland."
                                }
                            ]
                        }
                    />

                    <ServiceCards
                        title='Licensing Process'
                        services={
                            [
                                {
                                    title: "Consultation & Planning",
                                    text: "Define fund type (UCITS, AIF, PIF)."
                                },
                                {
                                    title: "Entity Incorporation",
                                    text: "Establish SICAV or other fund structure in Malta."
                                },
                                {
                                    title: "Application Preparation",
                                    text: "Prepare business plan, risk framework, AML/KYC compliance."
                                },
                                {
                                    title: "Submission to MFSA",
                                    text: "Full review of governance, capital, and structure."
                                },
                                {
                                    title: "Approval & Licensing",
                                    text: "Usually within 6–12 months."
                                }
                            ]
                        }
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={
                            [
                                {
                                    name: "Timeline",
                                    duration: "6–12 months.",
                                },
                                {
                                    name: "Setup Costs",
                                    description: "from €100,000+ (legal, compliance, fund structuring)."
                                },
                                {
                                    name: "Capital Requirement",
                                    description: "€125,000–€300,000+ depending on license type."
                                },
                                {
                                    name: "Annual Costs",
                                    description: "audits, custodians, MFSA supervision."
                                },

                            ]
                        }
                    />

                    <DetailsSection
                        title='Why Offshore Advisory?'
                        items={
                            [
                                {
                                    title: "Specialists in EU Fund Structuring",
                                    text: "Specialists in EU fund structuring and licensing."
                                },
                                {
                                    title: "Expertise",
                                    text: "Expertise in UCITS, AIFs, and PIFs."
                                },
                                {
                                    title: "End-to-End Services",
                                    text: "End-to-end services: incorporation, compliance, licensing, custodian onboarding."
                                },
                                {
                                    title: "Guidance",
                                    text: "Guidance on fund administrators, depositaries, and audit partners."
                                },
                                {
                                    title: "Comparative Insights",
                                    text: "Comparison: Malta vs Luxembourg, Ireland, and offshore options."
                                }
                            ]
                        }
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to launch an EU fund or asset management company?"
                        description="Malta offers UCITS, AIF, and PIF structures under MFSA, combining EU recognition with competitive costs compared to Luxembourg or Ireland."
                        buttonText="Book a Malta Fund License Consultation →"
                        buttonLink="/quote"
                    />


                </div>
            </section>
        </main>
    );
};
const faqData = [
    {
        question: "What’s the difference between UCITS, AIF, and PIF?",
        content: [
            { type: "answer", text: "UCITS = retail funds | AIF = professional alternative funds | PIF = flexible fund for HNWIs." },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "6–12 months, depending on fund type." },
        ],
    },
    {
        question: "What is the capital requirement?",
        content: [
            { type: "answer", text: "€125,000 minimum, €300,000+ for UCITS/AIF managers." },
        ],
    },
    {
        question: "Can Malta funds market in the EU?",
        content: [
            { type: "answer", text: "Yes — UCITS and AIFs have EEA passporting rights." },
        ],
    },
    {
        question: "Are PIFs recognized outside Malta?",
        content: [
            { type: "answer", text: "Yes — they are popular with private investors, family offices, and HNWIs, though not fully passportable." },
        ],
    },
];

const testimonialsData = [
    {
        quote: "We structured a hedge fund in Malta under the AIFM regime. Offshore Advisory helped us with compliance and custodian onboarding.",
        author: "Michael S.",
        role: "Fund Manager"
    },
    {
        quote: "Our PIF setup in Malta was smooth and flexible. Offshore Advisory made the process efficient and investor-ready.",
        author: "Sofia K.",
        role: "Asset Management Director"
    }
];
